import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';
import { DeletePaymentCardRequest, DeletePaymentCardResponse } from './types';
import { useBrowsePaymentCardApi } from './use-browse-payment-card-api';

export function useDeletePaymentCardMutationApi(id: string) {
  const endpoint = useCustomerEndpoint('paymentMethod');

  return useBaseMutation<DeletePaymentCardRequest, DeletePaymentCardResponse>(
    {
      url: `${endpoint}/${id}`,
      method: HttpMethod.delete,
    },
    {
      onSuccess: (data) => {
        baseQueryClient.setQueryData([useBrowsePaymentCardApi.name], data);
      },
    }
  );
}
